import React from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemModelTable } from "../model/qq-key-info-item.model";
import { Table } from "@mui/material";
import { QqResRowControl } from "./qq-res-row.control";
import TableBody from "@mui/material/TableBody";

export type QqResTableControlProps = StateDispatchProps &
  QqKeyInfoItemModelTable;

export const QqResTableControl: React.FunctionComponent<QqResTableControlProps> =
  ({ state, dispatch, rows }) => {
    return (
      <Table
        sx={{
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <TableBody>
          {rows.map((r, index) => (
            <QqResRowControl
              key={index}
              {...r}
              state={state}
              dispatch={dispatch}
            />
          ))}
        </TableBody>
      </Table>
    );
  };
